import styled from "styled-components";
import { ReactComponent as FlixxCoinSVG } from "assets/icons/flixx-coin.svg";
import { Link } from "react-router-dom";
import { decimalToHexStr } from "utils/numbers";

export const Container = styled(Link)`
  padding-right: 5px;

  position: relative;
  height: ${({ theme }) => theme.old.sizes.balance.medium.height};
  min-width: ${({ theme }) => theme.old.sizes.balance.medium.width};
  display: flex;
  align-items: center;

  cursor: pointer;
  border-radius: 8px;
  
  background-color: ${({ theme, $isDark }) => $isDark
    ? '#27272A'
    : theme.old.colors.balance.creators + decimalToHexStr(0.1)
  };
    border: ${({ theme, $isDark }) => $isDark
    ? '1px solid #3F3F46'
    : 'none'
  };


  & > span {
    width: 100%;
    text-align: center;
    color: ${({ theme, $isDark }) => $isDark ? theme.old.colors.white : theme.old.colors.black};
    font-size: ${({ theme }) => theme.old.fonts.size.normal};
    font-weight: ${({ theme }) => theme.old.fonts.weight.medium};
  }


  ${({ theme }) => theme.old.breakpoints.isMobile} {
    height: ${({ theme }) => theme.old.sizes.balance.small.height};
    min-width: ${({ theme }) => theme.old.sizes.balance.small.width};
  }
`

export const FlixxCoin = styled(FlixxCoinSVG)`
  margin-left: 3px;

  height: ${({ theme }) => `calc(${theme.old.sizes.balance.medium.coin} * .9)`};
  width: ${({ theme }) => `calc(${theme.old.sizes.balance.medium.coin} * .9)`};
  min-width: ${({ theme }) => `calc(${theme.old.sizes.balance.medium.coin} * .9)`};

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    height: ${({ theme }) => theme.old.sizes.balance.small.coin};
    width: ${({ theme }) => theme.old.sizes.balance.small.coin};
    min-width: ${({ theme }) => theme.old.sizes.balance.small.coin};
  }
`